import React from 'react';
import { Circle, CircleWrapper, Info, RadioButtonWithTextWrapper, Text, Title } from './RadioButtonWithTextStyles';

export interface IProps {
  id: string;
  title: string;
  text: string;
  checked?: boolean;
  onClickCallback?: () => void;
  index?: number;
  disabled?: boolean;
}

export const RadioButtonWithText: React.FC<IProps> = (props) => {
  const { title, text, checked, onClickCallback, index, disabled, ...rest } = props;

  return (
    <RadioButtonWithTextWrapper
      {...rest}
      key={index}
      className={`${checked ? ' checked' : ''}${disabled ? ' disabled' : ''}`}
      onClick={() => !disabled && onClickCallback && onClickCallback()}
    >
      <CircleWrapper>
        <Circle />
      </CircleWrapper>
      <Info>
        <Title>{title}</Title>
        <Text>{text}</Text>
      </Info>
    </RadioButtonWithTextWrapper>
  );
};
